import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'page',
    component: () => import('../views/index.vue')
  },
  {
    path: '/media',
    name: 'media',
    component: () => import('../views/mediaTypeTwo.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
